import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=62d0c0ed&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=ts&"
export * from "./Badge.vue?vue&type=script&lang=ts&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=62d0c0ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d0c0ed",
  null
  
)

export default component.exports